import * as Yup from "yup";
import { StringValidation, DropdownValidation } from "./PlanSchema";

export const AddKpiSchema = Yup.object().shape({
  // notes and allignment removed as per the client request dated 16th Aug 2021
  kpi: StringValidation.label("kpi"),
  // notes: StringValidation.label("notes"),
  weight: StringValidation.label("weight"),
  target: StringValidation.label("target"),  
  // alignment: DropdownValidation.label("alignment"),
  allocation: DropdownValidation.label("allocation"),
});
